export default __webpack_public_path__ + "static/93917-15b1f4d7e9e3ea8d3c8a80edf61b4789.jpg";